<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare content='查看智能营销码扫码领奖明细记录；默认显示近30天内的记录；红包“发放失败”表示由于商户余额不足、用户帐号异常、网络暂时繁忙等原因导致用户接收不到红包的情况。 <a href="">登录微信商户后台</a>查看商户余额。扫码领奖明细记录非实时显示，记录在领奖一分钟后显示。' :padding='false' class="m-b-20"></SmallSquare>
      <a-tabs v-model:activeKey="activeKey" destroyInactiveTabPane>
        <a-tab-pane :key="1" tab="产品码" forceRender>
          <scan></scan>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="箱码">
          <box></box>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { ref } from "vue";
import scan from './components/scan';
import box from './components/box';
export default {
  components: {scan,box },
  setup() {
    const activeKey = ref(1);
    return {
      activeKey
    };
  },
};
</script>